export const PATH_NAMES = {
	// Authentication
	LOGIN: 'login',
	LOGOUT: 'logout',
	AUTH: 'auth',
	CHANGE_PASSWORD: 'changePassword',
	SSO: 'sso',
	VERADIGM: 'veradigm',
	VERADIGM_LAUNCH: 'launch',

	// EHR redirects
	ATHENA: 'athena',
	ECW: 'ecw',

	// Summary
	SUMMARY: 'summary',
	GUESS_MATCH_NOT_FOUND: 'guess-match-not-found',

	// Demos / standalone
	AMBIENT_NOTE_DEMO: 'ambient-note-demo',
	MOBILE_LOGIN_QR: 'mobile-login-qr',

	// Quality
	QUALITY: 'quality',
	QUALITY_WORKSPACE: 'quality-workspace',
	QUALITY_ARCHIVE: 'quality-archive',
	QUALITY_PATIENTS: 'quality-patients',
	QUALITY_SATISFACTION_RATE: 'quality-satisfaction-rate',
	QUALITY_FIT: 'quality-fit',
	QUALITY_FIT_ADD_TEMPLATE: 'add-template',
	QUALITY_FIT_TEMPLATES: 'quality-fit-templates',
	QUALITY_TAB: 'quality-tab',

	// Pop Health
	POP_HEALTH_COST: 'pop-health-cost',
	POP_HEALTH_ADMISSIONS: 'pop-health-admissions',
	POP_HEALTH_RADV_AUDIT: 'pop-health-radv-audit',

	// Analytics
	ANALYTICS: 'analytics',
	ANALYTICS_QUICKSIGHT: 'qs',

	// Schedule
	SCHEDULE: 'schedule',

	// Files
	FILES: 'files',

	// Admin
	ADMIN: 'admin',
	ADMIN_INSERT_USERS: 'insert-users',
} as const satisfies Record<string, string>;

const {
	LOGIN,
	LOGOUT,
	AUTH,
	CHANGE_PASSWORD,
	SSO,
	VERADIGM,
	VERADIGM_LAUNCH,
	ATHENA,
	ECW,
	SUMMARY,
	GUESS_MATCH_NOT_FOUND,
	AMBIENT_NOTE_DEMO,
	MOBILE_LOGIN_QR,
	ANALYTICS_QUICKSIGHT,
	QUALITY,
	QUALITY_WORKSPACE,
	QUALITY_ARCHIVE,
	QUALITY_PATIENTS,
	QUALITY_SATISFACTION_RATE,
	QUALITY_FIT,
	QUALITY_FIT_ADD_TEMPLATE,
	QUALITY_FIT_TEMPLATES,
	QUALITY_TAB,
	POP_HEALTH_COST,
	POP_HEALTH_ADMISSIONS,
	POP_HEALTH_RADV_AUDIT,
	ANALYTICS,
	SCHEDULE,
	FILES,
	ADMIN,
	ADMIN_INSERT_USERS,
} = PATH_NAMES;

export type NavinaPathName = (typeof PATH_NAMES)[keyof typeof PATH_NAMES];

export const PATHS = {
	ROOT_PATH: '/',
	LOGIN_PATH: `/${LOGIN}`,
	LOGOUT_PATH: `/${LOGOUT}`,
	AUTH_CHANGE_PASSWORD_PATH: `/${AUTH}/${CHANGE_PASSWORD}`,
	SSO_PATH: `/${SSO}`,
	VERADIGM_LAUNCH_PATH: `/${VERADIGM}/${VERADIGM_LAUNCH}`,
	ATHENA_PATH: `/${ATHENA}`,
	ECW_PATH: `/${ECW}`,
	SUMMARY_GUESS_MATCH_NOT_FOUND_PATH: `/${SUMMARY}/${GUESS_MATCH_NOT_FOUND}`,
	AMBIENT_NOTE_DEMO_PATH: `/${AMBIENT_NOTE_DEMO}`,
	MOBILE_LOGIN_QR_PATH: `/${MOBILE_LOGIN_QR}`,
	ANALYTICS_QUICKSIGHT_PATH: `/${ANALYTICS_QUICKSIGHT}`,
	QUALITY_PATH: `/${QUALITY}`,
	QUALITY_WORKSPACE_PATH: `/${QUALITY_WORKSPACE}`,
	QUALITY_ARCHIVE_PATH: `/${QUALITY_ARCHIVE}`,
	QUALITY_PATIENTS_PATH: `/${QUALITY_PATIENTS}`,
	QUALITY_SATISFACTION_RATE_PATH: `/${QUALITY_SATISFACTION_RATE}`,
	QUALITY_FIT_PATH: `/${QUALITY_FIT}`,
	QUALITY_FIT_ADD_TEMPLATE_PATH: `/${QUALITY_FIT}/${QUALITY_FIT_ADD_TEMPLATE}`,
	QUALITY_FIT_TEMPLATES_PATH: `/${QUALITY_FIT_TEMPLATES}`,
	QUALITY_TAB_PATH: `/${QUALITY_TAB}`,
	POP_HEALTH_COST_PATH: `/${POP_HEALTH_COST}`,
	POP_HEALTH_ADMISSIONS_PATH: `/${POP_HEALTH_ADMISSIONS}`,
	POP_HEALTH_RADV_AUDIT_PATH: `/${POP_HEALTH_RADV_AUDIT}`,
	ANALYTICS_PATH: `/${ANALYTICS}`,
	SCHEDULE_PATH: `/${SCHEDULE}`,
	FILES_PATH: `/${FILES}`,
	FILES_UNIFIED_PATH: `/v2/${FILES}`,
	ADMIN_PATH: `/${ADMIN}`,
	ADMIN_INSERT_USERS_PATH: `/${ADMIN}/${ADMIN_INSERT_USERS}`,
} as const satisfies Record<string, `/${string}`>;

export type NavinaPath = (typeof PATHS)[keyof typeof PATHS];
